<div class="card" [class.flex-width]="flexWidth" data-test="deals-deal-info-card">
    <div *ngIf="deal.jacketTypeId === JacketType.Deal" class="deal-image-container">
        <img [src]="vehicleImage" (error)="showMissingImage($event)" alt="image of the vehicle you've purchased" data-test="deals-deal-vehicle-image" />
    </div>

    <!--Allow swap of buyer and cobuyer-->

    <!-- Deal info for all jacket types-->
    <div class="table-container" data-test="deals-buyer-info-table">
        <div class="card-padding align-center">
            <h3 style="width: 100%" data-test="deals-buyer-info-table-header">{{ dealOrJacket }} Information</h3>

            <div class="flex-end">
                <ng-container>
                    <mat-icon
                        class="deal-header-clipboard"
                        matTooltip="Audit Trail"
                        (click)="viewDealAuditTrail()"
                        data-test="deals-buyer-info-audit-trail-button"
                    >
                        content_paste
                    </mat-icon>
                    <ng-container *ngIf="canEditCustomer || isJacketDeleted">
                        <mat-icon class="vert-icon" [matMenuTriggerFor]="buyerMenu" data-test="deals-buyer-info-elipsis-expander-button">more_vert</mat-icon>
                        <mat-menu class="menu-actions" #buyerMenu="matMenu">
                            <ng-container>
                                <button mat-button (click)="editDealInfo()" data-test="deals-buyer-info-edit-button">
                                    Edit {{ dealOrJacket }} Information
                                </button>
                            </ng-container>
                        </mat-menu>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Deal Jacket Info -->
        <ng-container *ngIf="isDealJacketType">
            <div class="info-row">
                <p>
                    <span class="bolded">Deal #:</span> <span data-test="deals-buyer-info-deal-number">{{ deal.dealerDealNumber ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Deal Type Name:</span> <span data-test="deals-buyer-info-deal-type">{{ deal.dealTypeName ?? '' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket ID:</span> <span data-test="deals-buyer-info-deal-id">{{ deal.dealId ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Created By:</span>
                    <span data-test="storage-deal-info-created-by">{{ deal.createdByUser.firstName + ' ' + deal.createdByUser.lastName }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Finance Manager:</span>
                    <span data-test="storage-deal-info-created-on">{{ financeManager }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Deal Category:</span> <span data-test="consumer-docs-deal-info-jacket-status">{{ jacketStatus ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row" *ngIf="isJacketDeleted">
                <p>
                    <span class="bolded">Reason for Deletion:</span>
                    <span data-test="storage-deal-info-created-on">{{ deal.deleteReason ?? 'N/A' }}</span>
                </p>
            </div>
        </ng-container>

        <!-- Document Jacket Info -->
        <ng-container *ngIf="isDocumentJacketType">
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket ID:</span> <span data-test="consumer-docs-deal-info-deal-id">{{ deal.dealId ?? '' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket Type:</span>
                    <span data-test="consumer-docs-deal-info-rfr">
                        {{ reasonForRequest ?? 'N/A' }}
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Created By:</span>
                    <span data-test="consumer-docs-deal-info-created-by">{{ deal.createdByUser.firstName + ' ' + deal.createdByUser.lastName }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket Category:</span> <span data-test="consumer-docs-deal-info-jacket-status">{{ jacketStatus ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row" *ngIf="isJacketDeleted">
                <p>
                    <span class="bolded">Reason for Deletion:</span>
                    <span data-test="consumer-docs-deal-info-delete-reason">{{ deal.deleteReason ?? 'N/A' }}</span>
                </p>
            </div>
        </ng-container>

        <!-- Storage Jacket Info -->
        <ng-container *ngIf="isStorageJacketType">
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket ID:</span> <span data-test="storage-deal-info-deal-id">{{ deal.dealId ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Deal #:</span>
                    <span data-test="storage-deal-info-deal-number">{{ deal.dealerDealNumber ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Created By:</span>
                    <span data-test="storage-deal-info-created-by">{{ deal.createdByUser.firstName + ' ' + deal.createdByUser.lastName }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Jacket Category:</span> <span data-test="storage-deal-info-jacket-status">{{ jacketStatus ?? 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row" *ngIf="isJacketDeleted">
                <p>
                    <span class="bolded">Reason for Deletion:</span>
                    <span data-test="storage-deal-info-delete-reason">{{ deal.deleteReason ?? 'N/A' }}</span>
                </p>
            </div>
        </ng-container>
    </div>

    <!-- buyer info -->
    <div class="table-container" data-test="deals-buyer-info-table">
        <div class="card-padding align-center title-space">
            <h3 style="width: 100%" data-test="deals-buyer-info-table-header">Buyer Information</h3>

            <div class="flex-end">
                <ng-container>
                    <mat-icon
                        class="deal-header-clipboard"
                        matTooltip="Audit Trail"
                        (click)="viewAuditTrail('buyer')"
                        data-test="deals-buyer-info-audit-trail-button"
                    >
                        content_paste
                    </mat-icon>
                    <ng-container *ngIf="canEditCustomer">
                        <mat-icon class="vert-icon" [matMenuTriggerFor]="buyerMenu" data-test="deals-buyer-info-elipsis-expander-button">more_vert</mat-icon>
                        <mat-menu class="menu-actions" #buyerMenu="matMenu">
                            <!-- Cannot edit when customer has multiple dealers and already logged with successful MFA -->
                            <button
                                mat-button
                                data-test="deals-buyer-info-edit-button"
                                [class]="deal['buyer']?.dealerCount > 1 && !hasSuccessfulBuyerLogon ? 'disabled' : ''"
                                [disabled]="deal['buyer']?.dealerCount < 1 && !hasSuccessfulBuyerLogon"
                                [matTooltip]="
                                    deal['buyer']?.dealerCount > 1 && !hasSuccessfulBuyerLogon
                                        ? 'Sorry, this user is unable to be updated. Please have the customer update their information.'
                                        : ''
                                "
                                (click)="deal['buyer']?.dealerCount > 1 && !hasSuccessfulBuyerLogon ? undefined : editBuyerInfo('buyer')"
                            >
                                Edit Buyer Information
                            </button>

                            <button
                                *ngIf="isDealJacketType"
                                mat-button
                                data-test="deals-buyer-info-resend-welcome-link-button"
                                [class]="!hasSuccessfulBuyerLogon ? 'disabled' : ''"
                                [disabled]="!hasSuccessfulBuyerLogon"
                                [matTooltip]="
                                    !hasSuccessfulBuyerLogon
                                        ? 'Sorry, this user has already logged in to the system, so the \'Send Welcome Message\' will no longer work. Please have the user click the \'Forgot Password\' link on the logon page.'
                                        : ''
                                "
                                (click)="hasSuccessfulBuyerLogon ? resendLink('buyer') : undefined"
                            >
                                Send Welcome Message
                            </button>
                        </mat-menu>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div>
            <info-detail
                [isDealsPage]="true"
                *ngIf="buyerIdVerificationResults"
                [class]="idVerificationClass(buyerIdVerificationResults)"
                label="{{ buyerIdVerificationResults.shortDisplayName }}"
                matTooltip="{{ showSubmitForReviewForBuyer ? '' : 'Show ' + buyerIdVerificationResults.shortDisplayName + ' Verification Details' }}"
                matTooltipPosition="above"
                data-test="deals-buyer-info-drivers-license-results-row"
            >
                <div class="id-check-status-wrapper" (click)="idVerificationResultsClick(buyerIdVerificationResults)">
                    <p class="label" style="display: flex; justify-content: space-between">
                        {{ buyerIdVerificationResults.shortDisplayName }}:&nbsp;{{
                            showSubmitForReviewForBuyer && disableSubmitForReview ? 'Validation Not Performed' : buyerIdVerificationResults.statusDescription
                        }}
                    </p>
                    <div *ngIf="resultsAvailable(buyerIdVerificationResults)" class="id-check-status-icon" mat-tooltip="Show ID Verification Details">
                        <mat-icon> launch </mat-icon>
                    </div>
                </div>
                <div
                    class="submitForValidation"
                    matTooltip="{{
                        disableSubmitForReview
                            ? 'You have reached the maximum number of ID validations this month. Unlimited validations are available as part of an add-on package. Contact us at' +
                              tenantSupportPhone +
                              'to learn more.'
                            : ''
                    }}"
                >
                    <button
                        *ngIf="showSubmitForReviewForBuyer"
                        (click)="submitForValidation(buyerIdVerificationResults)"
                        disabled="{{ disableSubmitForReview }}"
                        mat-button
                        class="whiteBackground small"
                    >
                        Submit For Validation
                    </button>
                </div>
            </info-detail>
        </div>
        <div class="buyer-info-row">
            <p>
                <span class="bolded"> Buyer:</span>
                <span data-test="deals-buyer-info-name">{{ deal?.buyer ? deal?.buyer?.firstName + ' ' + deal?.buyer?.lastName : 'N/A' }}</span>
            </p>
        </div>
        <div class="buyer-info-row">
            <p>
                <span class="bolded">Mobile Phone:</span> <span data-test="deals-buyer-info-phone">{{ importPhone(this.deal?.buyer?.phone) }}</span>
            </p>
        </div>
        <div class="buyer-info-row">
            <p>
                <span class="bolded">Email:</span>
                <span data-test="deals-buyer-info-email">{{ deal?.buyer?.email !== '' ? deal?.buyer?.email : 'N/A' }}</span>
            </p>
        </div>
    </div>

    <!-- cobuyer info -->
    <ng-container *ngIf="deal.coBuyer?.firstName">
        <div class="table-container" data-test="deals-cobuyer-info-table">
            <div class="card-padding align-center title-space">
                <h3 style="width: 100%" data-test="deals-cobuyer-info-table-header">Co-Buyer Information</h3>
                <div class="flex-end">
                    <mat-icon
                        class="deal-header-clipboard"
                        matTooltip="Audit Trail"
                        (click)="viewAuditTrail('coBuyer')"
                        data-test="deals-cobuyer-info-audit-trail-button"
                    >
                        content_paste
                    </mat-icon>
                    <ng-container *ngIf="canEditCustomer">
                        <mat-icon class="vert-icon" data-test="deals-cobuyer-info-ellipsis-expander-button" [matMenuTriggerFor]="coBuyerMenu">
                            more_vert
                        </mat-icon>
                        <mat-menu class="menu-actions" #coBuyerMenu="matMenu">
                            <button
                                mat-button
                                data-test="deals-cobuyer-info-edit-button"
                                [class]="(deal['coBuyer'].dealerCount > 1 && !hasSuccessfulCoBuyerLogon) || !canEditCustomer ? 'disabled' : ''"
                                [disabled]="(deal['coBuyer'].dealerCount > 1 && !hasSuccessfulCoBuyerLogon) || !canEditCustomer"
                                [matTooltip]="
                                    (deal['coBuyer'].dealerCount > 1 && !hasSuccessfulCoBuyerLogon) || !canEditCustomer
                                        ? 'Sorry, this user is unable to be updated. Please have the customer update their information.'
                                        : ''
                                "
                                (click)="
                                    (deal['coBuyer']?.dealerCount > 1 && !hasSuccessfulCoBuyerLogon) || !canEditCustomer ? undefined : editBuyerInfo('coBuyer')
                                "
                            >
                                Edit Co-Buyer Information
                            </button>

                            <button
                                *ngIf="isDealJacketType"
                                mat-button
                                data-test="deals-cobuyer-info-resend-welcome-link"
                                [class]="!hasSuccessfulCoBuyerLogon ? 'disabled' : ''"
                                [disabled]="!hasSuccessfulCoBuyerLogon"
                                [matTooltip]="
                                    !hasSuccessfulCoBuyerLogon
                                        ? 'Sorry, this user has already logged in to the system, so the \'Send Welcome Message\' will no longer work. Please have the user click the \'Forgot Password\' link on the logon page.'
                                        : ''
                                "
                                (click)="hasSuccessfulCoBuyerLogon ? resendLink('cobuyer') : undefined"
                            >
                                Send Welcome Message
                            </button>

                            <button
                                mat-button
                                data-test="deals-cobuyer-info-remove-cobuyer"
                                class="delete"
                                [disabled]="!isDealOpen"
                                [matTooltip]="!isDealOpen ? 'Sorry, the deal must be Open to remove the Co-Buyer.' : ''"
                                (click)="removeCobuyer()"
                            >
                                Remove Co-Buyer
                            </button>
                        </mat-menu>
                    </ng-container>
                </div>
            </div>
            <info-detail
                [isDealsPage]="true"
                *ngIf="cobuyerIdVerificationResults"
                [class]="idVerificationClass(cobuyerIdVerificationResults)"
                label="{{ cobuyerIdVerificationResults.shortDisplayName }}"
                matTooltip="{{ showSubmitForReviewForCoBuyer ? '' : 'Show ' + cobuyerIdVerificationResults.shortDisplayName + ' Verification Details' }}"
                matTooltipPosition="above"
                data-test="deals-cobuyer-info-drivers-license-results-row"
            >
                <div class="id-check-status-wrapper" (click)="idVerificationResultsClick(cobuyerIdVerificationResults)">
                    <p class="label" data-test="deals-cobuyer-info-drivers-license-results-status " style="display: flex; justify-content: space-between">
                        {{ cobuyerIdVerificationResults.shortDisplayName }}:&nbsp;{{
                            showSubmitForReviewForCoBuyer && disableSubmitForReview
                                ? 'Validation Not Performed'
                                : cobuyerIdVerificationResults.statusDescription
                        }}
                    </p>

                    <div *ngIf="resultsAvailable(cobuyerIdVerificationResults)" class="id-check-status-icon" mat-tooltip="Show ID Verification Details">
                        <mat-icon> launch </mat-icon>
                    </div>
                </div>
                <div
                    class="submitForValidation"
                    matTooltip="{{
                        disableSubmitForReview
                            ? 'You have reached the maximum number of ID validations this month. Unlimited validations are available as part of an add-on package. Contact us at' +
                              tenantSupportPhone +
                              'to learn more.'
                            : ''
                    }}"
                >
                    <button
                        *ngIf="showSubmitForReviewForCoBuyer"
                        (click)="submitForValidation(cobuyerIdVerificationResults)"
                        disabled="{{ disableSubmitForReview }}"
                        mat-button
                        class="whiteBackground small"
                    >
                        Submit For Validation
                    </button>
                </div>
            </info-detail>
            <div class="info-row">
                <p>
                    <span class="bolded">Co-Buyer:</span>
                    <span data-test="deals-cobuyer-info-name">{{ deal.coBuyer ? deal.coBuyer.firstName + ' ' + deal.coBuyer.lastName : 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p data-test="deals-cobuyer-info-phone">
                    <span class="bolded">Mobile Phone:</span> <span>{{ importPhone(this.deal.coBuyer.phone) }}</span>
                </p>
            </div>
            <div class="info-row">
                <p data-test="deals-cobuyer-info-email">
                    <span class="bolded"> Email:</span>
                    <span>{{ deal.coBuyer.email !== '' && deal.coBuyer.email !== null ? deal.coBuyer.email : 'N/A' }}</span>
                </p>
            </div>
        </div>
    </ng-container>
    <!--START HERE -->
    <ng-container>
        <div class="table-container" data-test="deals-vehicle-info-table">
            <div class="card-padding align-center title-space">
                <h3 data-test="deals-vehicle-info-table-header">Vehicle Information</h3>
                <div class="flex-end">
                    <ng-container>
                        <mat-icon
                            class="deal-header-clipboard"
                            matTooltip="Audit Trail"
                            (click)="viewAuditTrailForVehicle()"
                            data-test="deals-vehicle-info-audit-trail-button"
                        >
                            content_paste
                        </mat-icon>
                        <ng-container *ngIf="canEditCustomer">
                            <mat-icon class="vert-icon" [matMenuTriggerFor]="vehicleMenu" data-test="deals-vehicle-info-elipsis-expander-button"
                                >more_vert</mat-icon
                            >

                            <mat-menu class="menu-actions" #vehicleMenu="matMenu">
                                <span [matTooltip]="'Edit vehicle information'">
                                    <button mat-button (click)="editVehicleInfo()" data-test="deals-vehicle-info-edit-button">Edit Vehicle Information</button>
                                </span>
                            </mat-menu>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="info-row" *ngIf="vehicleDisplayDescription">
                <p data-test="deals-vehicle-info-vehicle-label">
                    <span class="bolded">Vehicle:</span>
                    <span data-test="deals-vehicle-info-vehicle">{{ vehicleDisplayDescription }} </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> VIN:</span>
                    <span data-test="deals-vehicle-info-vin">{{ deal.vehicle.vin !== '' && deal.vehicle.vin !== null ? deal.vehicle.vin : 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> Stock ID:</span> <span data-test="deals-vehicle-info-stock-id">{{ deal.vehicle?.stockNumber || 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> New/CPO/Used:</span>
                    <span data-test="deals-vehicle-info-vehicle-status">{{ deal.vehicle?.vehicleExt?.status || 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> Mileage:</span> <span data-test="deals-vehicle-info-stock-id">{{ deal.vehicle?.mileage || 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row" *ngIf="this.showVehiclePrice">
                <p>
                    <span class="bolded">Price Point:</span>
                    <span data-test="deals-vehicle-info-price-point">
                        <span *ngIf="deal.vehicle.vehicleExt.priceInternet > 0">
                            {{ deal.vehicle.vehicleExt?.priceInternet | currency: 'USD' }}
                        </span>
                        <span *ngIf="deal.vehicle.vehicleExt?.priceInternet <= 0">N/A</span>
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Body Style:</span>
                    <span data-test="deals-vehicle-info-body-style">
                        {{ deal.vehicle.bodyStyle !== '' && deal.vehicle.bodyStyle !== null ? deal.vehicle.bodyStyle : 'N/A' }}
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Trim:</span>
                    <span data-test="deals-vehicle-info-trim">{{ deal.vehicle.trim !== '' && deal.vehicle.trim !== null ? deal.vehicle.trim : 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> Ext. Color:</span>
                    <span data-test="deals-vehicle-info-ext-color">
                        {{
                            deal.vehicle.vehicleExt.exteriorColor !== '' && deal.vehicle.vehicleExt.exteriorColor !== null
                                ? deal.vehicle.vehicleExt.exteriorColor
                                : 'N/A'
                        }}
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Int. Color:</span>
                    <span data-test="deals-vehicle-info-int-color">
                        {{
                            deal.vehicle.vehicleExt.interiorColor !== '' && deal.vehicle.vehicleExt.interiorColor !== null
                                ? deal.vehicle.vehicleExt.interiorColor
                                : 'N/A'
                        }}
                    </span>
                </p>
            </div>
        </div>
    </ng-container>
    <ng-container>
        <div class="table-container" data-test="deals-trade-vehicle-info-table">
            <div class="card-padding align-center title-space">
                <h3 data-test="deals-trade-vehicle-info-table-header">Trade-In Vehicle Information</h3>
                <div class="flex-end">
                    <ng-container>
                        <mat-icon
                            class="deal-header-clipboard"
                            matTooltip="Audit Trail"
                            (click)="viewAuditTrailForVehicle(VehicleType.TradeIn)"
                            data-test="deals-trade-vehicle-info-audit-trail-button"
                        >
                            content_paste
                        </mat-icon>
                        <ng-container *ngIf="canEditCustomer">
                            <mat-icon class="vert-icon" [matMenuTriggerFor]="vehicleMenu" data-test="deals-trade-vehicle-info-elipsis-expander-button"
                                >more_vert</mat-icon
                            >

                            <mat-menu class="menu-actions" #vehicleMenu="matMenu">
                                <button mat-button (click)="editVehicleInfo(VehicleType.TradeIn)" data-test="deals-trade-vehicle-info-edit-button">
                                    Edit Trade-In Vehicle Information
                                </button>
                                <button
                                    mat-button
                                    (click)="removeTradeIn(deal, deal.dealerId)"
                                    [disabled]="!tradeInExists"
                                    class="delete"
                                    [class.disabled]="!tradeInExists"
                                    data-test="deals-trade-vehicle-info-remove-button"
                                >
                                    Remove Trade-In Vehicle
                                </button>
                            </mat-menu>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="info-row" *ngIf="tradeInVehicleDisplayDescription">
                <p data-test="deals-trade-vehicle-info-vehicle-label">
                    <span class="bolded">Vehicle:</span>
                    <span data-test="deals-trade-vehicle-info-vehicle">{{ tradeInVehicleDisplayDescription }} </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> VIN:</span>
                    <span data-test="deals-trade-vehicle-info-vin">{{
                        deal.tradeInVehicle.vin !== '' && deal.tradeInVehicle.vin !== null ? deal.tradeInVehicle.vin : 'N/A'
                    }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> Mileage:</span> <span data-test="deals-trade-vehicle-info-stock-id">{{ deal.tradeInVehicle?.mileage || 'N/A' }}</span>
                </p>
            </div>
            <div class="info-row" *ngIf="this.showVehiclePrice">
                <p>
                    <span class="bolded">Price Point:</span>
                    <span data-test="deals-trade-vehicle-info-price-point">
                        <span *ngIf="deal.tradeInVehicle.vehicleExt.priceInternet > 0">
                            {{ deal.tradeInVehicle.vehicleExt?.priceInternet | currency: 'USD' }}
                        </span>
                        <span *ngIf="deal.tradeInVehicle.vehicleExt?.priceInternet <= 0">N/A</span>
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Body Style:</span>
                    <span data-test="deals-trade-vehicle-info-body-style">
                        {{ deal.tradeInVehicle.bodyStyle !== '' && deal.tradeInVehicle.bodyStyle !== null ? deal.tradeInVehicle.bodyStyle : 'N/A' }}
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Trim:</span>
                    <span data-test="deals-trade-vehicle-info-trim">{{
                        deal.tradeInVehicle.trim !== '' && deal.tradeInVehicle.trim !== null ? deal.tradeInVehicle.trim : 'N/A'
                    }}</span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded"> Ext. Color:</span>
                    <span data-test="deals-trade-vehicle-info-ext-color">
                        {{
                            deal.tradeInVehicle.vehicleExt.exteriorColor !== '' && deal.tradeInVehicle.vehicleExt.exteriorColor !== null
                                ? deal.tradeInVehicle.vehicleExt.exteriorColor
                                : 'N/A'
                        }}
                    </span>
                </p>
            </div>
            <div class="info-row">
                <p>
                    <span class="bolded">Int. Color:</span>
                    <span data-test="deals-trade-vehicle-info-int-color">
                        {{
                            deal.tradeInVehicle.vehicleExt.interiorColor !== '' && deal.tradeInVehicle.vehicleExt.interiorColor !== null
                                ? deal.tradeInVehicle.vehicleExt.interiorColor
                                : 'N/A'
                        }}
                    </span>
                </p>
            </div>
        </div>
    </ng-container>
</div>

<ddj-spinner *ngIf="isLoading" phrase="{{ loadingMessage }}"></ddj-spinner>
